import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from '../locales/es.json';
import en from '../locales/en.json';
import ca from '../locales/ca.json';
import catalogueStrings from '../locales/catalogue';
import onboardingStrings from '../locales/onboarding';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      ca: { translation: ca },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'ca'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'zbilling_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

// Feature bundles kept outside the main locale files (merged deep, never
// overwriting an existing key).
[catalogueStrings, onboardingStrings].forEach((bundle) => {
  Object.entries(bundle).forEach(([lng, res]) => {
    i18n.addResourceBundle(lng, 'translation', res, true, false);
  });
});

export default i18n;

// Keep <html lang> in step with the UI language. index.html ships lang="es";
// a wrong/stale value makes Chrome classify a Spanish page as English and offer
// (or, with "always translate", silently apply) a translation — which rewrites
// the DOM under React and crashes pages (see lib/domGuard.js).
const syncHtmlLang = (lng) => {
  try { document.documentElement.lang = (lng || 'es').slice(0, 2); } catch { /* SSR / tests */ }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);
